import { signOut } from "@/utils/signout";
import { checkToken, getIdToken, refreshSession } from "./cognitoAuth";

type UserToken = {
  "custom:access_control": string;
  "custom:client_access": string;
  "custom:contactid": string;
  "custom:user_id": string;
};

type UserClaims = {
  clientAccess: {
    canAccessBillingPortal?: boolean;
  };
};

type UserTokenWithClaims = UserToken & {
  claims: UserClaims;
};

export const authApi = {
  getUserToken: async () => {
    const { isValid } = await checkToken();

    if (!isValid) {
      const { success, token } = await refreshSession();
      if (!success || !token) {
        await signOut();
        throw new Error("Unable to refresh token");
      }
      return token.toString();
    }

    const { success, token } = await getIdToken();
    if (!success || !token) {
      await signOut();
      throw new Error("Unable to retrieve token");
    }
    return token.toString();
  },
  getCognitoUser: async () => {
    await authApi.getUserToken();

    const { success, token: idToken } = await getIdToken();
    if (!success || !idToken) {
      await signOut();
      throw new Error("Unable to retrieve token");
    }
    const token = idToken.payload as UserToken;
    const clientAccessClaims = JSON.parse(
      token["custom:client_access"] || "{}"
    );

    const tokenWithClaims: UserTokenWithClaims = {
      ...token,
      claims: {
        clientAccess: {
          canAccessBillingPortal: clientAccessClaims.can_access_billing_portal,
        },
      },
    };

    return tokenWithClaims;
  },
};
